import React, { useState, useEffect } from 'react'
import Modal from '@material-ui/core/Modal'
import { useDispatch } from 'react-redux'
import { Grid, Typography } from '@material-ui/core'
import { useHistory, Link } from 'react-router-dom'
import { signInAction, logOut } from '../../../modules/session/actions'
import InputGeogoding from './InputLocations'
import api from '../../../api/auth'
import { Input, Button, CheckboxCustom, Notification } from '../index'
import c from 'classnames'
import { useStyles } from './style'

const SignUpModal = ({ open, onClose, user, setWasExist }) => {
  const [name, setName] = useState('')
  const [town, setTown] = useState('')
  const [error, setError] = useState('')
  const [checked, setChecked] = useState(false)
  const [openAlert, setOpenAlert] = useState()
  const dispatch = useDispatch()
  const history = useHistory()
  const classes = useStyles()

  const onDelete = () => {
    if (!checked) {
      api.deleteProfile(user?.accessKey)
        .then(res => {
          if (res?.data?.status === 'ok') {
            dispatch(signInAction(null))
            dispatch(logOut(null))
            onClose()
            history.push('/')
          }
        })
    }
  }

  const signUp = () => {
    if (!name) {
      setError('Name is required')
    } else {
      setError('')
      if (checked) {
        api?.updateUser(user?.accessKey, {
          name: name,
          town: town?.value?.structured_formatting?.main_text,
          email: user?.user?.email,
          uuid: user?.user?.uuid,
        }).then(res => {
          if (res?.data?.user?.uuid) {
            dispatch(signInAction({
              accessKey: user?.accessKey,
              user: { ...res?.data?.user },
            }))
            onClose()
            history.push('/sign-up/first-session')
            setWasExist(true)
          } else {
            setOpenAlert(res?.data?.error?.message)
          }
        })
      }
    }
  }

  useEffect(() => {
    if (user?.user?.name) {
      setName(user?.user?.name)
    }
  }, [user?.user?.name])

  return (
    <>
      <Notification text={openAlert} open={openAlert} type='error' onClose={setOpenAlert} />
      <Modal className={classes.modalBack} open={open} onClose={onDelete}>
        <div className={classes.paper}>
          <Typography className={classes.title}>
            Set up your account to <br /> proceed
          </Typography>
          <Typography className={classes.subTitle}>You may change your name <br /> to stay anonymous</Typography>
          <Input
            onChange={e => setName(e?.target?.value)}
            name='Name'
            id='name'
            placeholder='Name'
            type='text'
            customClass={classes.inputCustom}
            error={error}
            helperText={error}
            value={name}
            onEditMess
            fullWidth
          />
          <InputGeogoding value={town} setValue={setTown} defaultValue={user?.user?.town} />
          <Grid className={classes.loginCheckBox}>
            <CheckboxCustom
              onChange={e => setChecked(e?.target?.checked)}
              customClass={classes.checkBox}
              text={<span className={classes.termsLink}>I agree with <Link to='/terms' target='_blank'>Terms of Use</Link> and <Link to='/privacy' target='_blank'>Privacy Policy</Link></span>}
              value={checked}
            />
          </Grid>
          <Button onClick={signUp} className={c(classes.btnRegister, checked && classes.btnRegisterActive)}>Continue</Button>
        </div>
      </Modal>
    </>
  )
}

export default SignUpModal
